module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/homes_bg-b7c55a032341032d67d949bbb5301fef.jpg";